import { render, staticRenderFns } from "./ProductSensorForm.vue?vue&type=template&id=c7975ff0&scoped=true"
import script from "./ProductSensorForm.vue?vue&type=script&lang=js"
export * from "./ProductSensorForm.vue?vue&type=script&lang=js"
import style0 from "./ProductSensorForm.vue?vue&type=style&index=0&id=c7975ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7975ff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
